import React from "react";
import Game from "../Game/Game";
import "./App.css";

function App() {
  return <Game />;
}

export default App;
